import React from 'react';
import { Menu, MenuItem } from '@material-ui/core';
import { AnchorElementProps } from '@domain/types/prop.types';
import { UserMenuListIcon, VersionItem } from '@components/app.chrome/user.menu.styles';
import { ListLink } from '@components/list.link';
import { RawMenuItem } from '@components/raw.menu.item';

interface UserMenuProps extends AnchorElementProps {
  signOut(): void;
}

const UserMenu = ({ anchorEl, onClearAnchor, signOut }: UserMenuProps) => {
  return (
    <Menu
      id='user-menu'
      anchorEl={anchorEl}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      keepMounted
      open={!!anchorEl}
      onClose={onClearAnchor}
      PaperProps={{ style: { width: 220 } }}
    >
      <RawMenuItem onClick={onClearAnchor}>
        <ListLink to='/profile'>
          <UserMenuListIcon>manage_accounts</UserMenuListIcon> Profile
        </ListLink>
      </RawMenuItem>
      <MenuItem onClick={signOut}>
        <UserMenuListIcon>logout</UserMenuListIcon> Logout
      </MenuItem>
      <VersionItem />
    </Menu>
  );
};

export default UserMenu;
